import AuthService from '../../utilities/services/auth.service'

import { HensonFundReportWrapper } from '../../components'

export default function HensonFundReportPage() {
  const organization = AuthService.getOrg()[0]

  return <HensonFundReportWrapper organization={organization} />
}
